<template>
  <div class="contents">
    <div class="d-flex section-title-with-back">
      <img src="@/assets/images/Icon ionic-md-settings_bk.png" alt="" width="27.3" height="25.2" />
      <p class="title-bk">設定</p>
    </div>
    <div class="d-flex section-subtitle-with-back">
      <router-link :to="{ name: 'home' }">戻る</router-link>
    </div>
    <HomeItem imagePath="Icon awesome-key.png" title="パスワード変更" forwardPath="teacher-change-password"></HomeItem>
  </div>
</template>

<script>
import HomeItem from '@/components/home/HomeItem.vue';

export default {
  components: {
    HomeItem,
  },
};
</script>

<style lang="scss" scoped></style>
